import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import ErrorBoundary from '../../error-boundary';
import GoToNextModalHotkey from '../../hotkeys/go-to-next-modal';
import GoToPreviousModalHotkey from '../../hotkeys/go-to-previous-modal';
import LinkedModalNavigationButton from '../../shared/linked-modal-navigation-button';

import { ShipmentDetailsModalContentContainer } from './shipment-details-modal-content/shipment-details-modal-content-container';

import style from './shipment-details-modal.module.less';

export const ShipmentDetailsModal = ({
  modalFrameworkMethods: { closeModal },
  nextShipmentDetailsUrl = null,
  previousShipmentDetailsUrl = null,
  fulfillmentPlanId,
  shipmentDetailModalId,
}) => {
  const [nextShipmentUrl, setNextShipmentUrl] = useState(nextShipmentDetailsUrl);
  const [previousShipmentUrl, setPreviousShipmentUrl] = useState(previousShipmentDetailsUrl);
  const showArrows = nextShipmentUrl || previousShipmentUrl;
  const navigateTo = useNavigate();

  // If these urls suddenly change as a result of a neighboring record changing, we
  // want to update it in state to reflect the new neighbor(s), but if they change
  // because this item changes status and is no longer in the current filtered view,
  // we want to keep memory of the previous values so that the user can still arrow
  // to the next or previous record in the grid, without having to close and reopen.
  if (nextShipmentDetailsUrl && nextShipmentDetailsUrl !== nextShipmentUrl) {
    setNextShipmentUrl(nextShipmentDetailsUrl);
  }

  if (previousShipmentDetailsUrl && previousShipmentDetailsUrl !== previousShipmentUrl) {
    setPreviousShipmentUrl(previousShipmentDetailsUrl);
  }

  return (
    <div className={style['shipment-details-wrapper']}>
      <div
        className={style['shipment-details-wrapper-background']}
        data-testid='shipment-details-wrapper-background'
        onClick={closeModal}
      />
      {showArrows && (
        <LinkedModalNavigationButton
          arrowDirection='left'
          className={style['shipment-details-arrow-previous']}
          disabled={!previousShipmentUrl}
          hotkey={GoToPreviousModalHotkey}
          href={previousShipmentUrl}
          navigateTo={navigateTo}
        />
      )}
      <Modal className={style['shipment-details-modal']}>
        <ModalBody className={style['shipment-details-modal-body']}>
          <ErrorBoundary errorMessageId='shipmentDetails'>
            <ShipmentDetailsModalContentContainer
              closeModal={closeModal}
              fulfillmentPlanId={fulfillmentPlanId}
              shipmentDetailModalId={shipmentDetailModalId}
            />
          </ErrorBoundary>
        </ModalBody>
      </Modal>
      {showArrows && (
        <LinkedModalNavigationButton
          arrowDirection='right'
          className={style['shipment-details-arrow-next']}
          disabled={!nextShipmentUrl}
          hotkey={GoToNextModalHotkey}
          href={nextShipmentUrl}
          navigateTo={navigateTo}
        />
      )}
    </div>
  );
};

ShipmentDetailsModal.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  nextShipmentDetailsUrl: PropTypes.string,
  previousShipmentDetailsUrl: PropTypes.string,
  shipmentDetailModalId: PropTypes.string.isRequired,
};
